import CircularProgress from '@mui/material/CircularProgress';
import { grey } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Image from 'components/Image';
import React, { useState } from 'react';
import { getChainPost } from '../../helpers/chainActions';
import hive from '../../helpers/hive';
import steem from '../../helpers/steem';
import HiveLogo from '../../images/hive-logo.svg';
import SteemLogo from '../../images/steem-logo.svg';

const whiteprimary = createTheme({
  palette: {
    primary: grey,
  },
});

const ChainDetailIcon = ({ author, permlink, chain }) => {
  const [payoutValue, setPayoutValue] = useState(undefined);
  const [isPending, setIsPending] = useState(false);

  let logo;
  if (chain === 'hive') logo = HiveLogo;
  else if (chain === 'steem') logo = SteemLogo;

  const getDetails = () => {
    getChainPost(chain === 'hive' ? hive : steem, author, permlink).then(
      post => {
        if (!post) return;
        const { pending_payout_value, total_payout_value, last_payout } = post;
        if (last_payout === '1970-01-01T00:00:00' && pending_payout_value) {
          setPayoutValue(
            parseFloat(
              pending_payout_value.substring(
                0,
                pending_payout_value.length - 3,
              ),
            ) / 2,
          );
          setIsPending(true);
        } else if (total_payout_value)
          setPayoutValue(
            total_payout_value.substring(0, total_payout_value.length - 3),
          );
      },
    );
  };

  if (!author || !permlink) return <></>;

  return (
    <>
      <Tooltip
        title={
          payoutValue !== undefined ? (
            `${payoutValue} $ ${isPending ? ' (Pending)' : ''}`
          ) : (
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={whiteprimary}>
                <CircularProgress className="mt-1" size={15} />
              </ThemeProvider>
            </StyledEngineProvider>
          )
        }
        onOpen={getDetails}
        arrow
      >
        <IconButton
          className="ml-1"
          size="small"
          color="primary"
          aria-label="Details"
        >
          <a
            href={`https://${
              chain === 'steem' ? 'steemd' : 'peakd'
            }.com/@${author}/${permlink}`}
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            <Image src={logo} alt={`${chain} logo`} width={25} height={25} />
          </a>
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ChainDetailIcon;
